import { navigate } from "gatsby";
import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles: ("user" | "admin")[];
}

const ProtectedRoute = ({ children, allowedRoles }: ProtectedRouteProps) => {
  const { userRole, isAuthenticated } = useAuth();
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {setIsClient(true)}, []);
  if (!isClient) return <div>Loading...</div>;
  // Redirect if the user is not authenticated or not authorized
  if (userRole === "public" || !isAuthenticated || !allowedRoles.includes(userRole as "user" | "admin")) {
    (navigate as unknown as (path: string) => void)("/403");
    return null;
  }
    
  return <>{children}</>;
};

export default ProtectedRoute;